export default function SkeletonPost() {
    return (
        <div className="post skeleton-post">

            <div className="post-header">
                <div className="skeleton avatar"></div>

                <div className="post-user-info">
                    <div className="skeleton name"></div>
                    <div className="skeleton date"></div>
                </div>
            </div>

            <div className="skeleton text"></div>
            <div className="skeleton image"></div>

            <div className="post-actions">
                <div className="skeleton btn"></div>
                <div className="skeleton btn"></div>
                <div className="skeleton btn"></div>
            </div>

        </div>
    );
}